import { render, staticRenderFns } from "./loginByWxWeb.vue?vue&type=template&id=587a2adc&scoped=true&"
import script from "./loginByWxWeb.vue?vue&type=script&lang=js&"
export * from "./loginByWxWeb.vue?vue&type=script&lang=js&"
import style0 from "./loginByWxWeb.vue?vue&type=style&index=0&id=587a2adc&lang=scss&scoped=true&"
import style1 from "./loginByWxWeb.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a2adc",
  null
  
)

export default component.exports